"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthErrorResponse = exports.AuthErrorCode = exports.ScrapiErrorMessage = exports.SCRAPI_ERROR_STATUS = void 0;
const zod_1 = require("zod");
/**
 * Any time we want to declare a specific error contract, we should use an
 * unassigned http status code. This allows things like proxy servers, future
 * middleware, etc. to return generic errors without breaking our contract
 *
 * The list of http codes is here - anything on the list marked unassigned is
 * fair game, but for now we are making do with a single code-- 420.
 *
 * https://www.iana.org/assignments/http-status-codes/http-status-codes.xhtml
 *
 */
exports.SCRAPI_ERROR_STATUS = 420;
exports.ScrapiErrorMessage = {
    [exports.SCRAPI_ERROR_STATUS]: zod_1.z.object({ message: zod_1.z.string() }),
};
exports.AuthErrorCode = zod_1.z.enum([
    'CANNOT_FIND_USER',
    'EMAIL_ALREADY_IN_USE',
    'EMAIL_DOES_NOT_EXIST',
    'INCORRECT_PASSCODE',
    'INVALID_CREDENTIALS',
    'INVALID_EMAIL_ADDRESS',
    'MALFORMED_EMAIL_ADDRESS',
    'MISSING_EMAIL_ADDRESS',
    'MISSING_NAME',
    'MISSING_NEW_PASSWORD',
    'MISSING_ONE_TIME_CODE',
    'MISSING_ONE_TIME_CODE_ID',
    'MISSING_OLD_PASSWORD',
    'MISSING_PASSWORD',
    'MISSING_TOKEN',
    'OTP_EXPIRED_OR_USED',
    'RESET_PASSWORD',
    'SESSION_NOT_FOUND',
    'STYTCH_DISABLED',
    'TOO_MANY_REQUESTS',
    'UNDELIVERABLE_EMAIL',
    'UNEXPECTED_ERROR',
    'USER_ALREADY_IN_STYTCH',
    'USER_NOT_IN_STYTCH',
    'WEAK_PASSWORD',
    'INVALID_ASSOCIATION',
]);
exports.AuthErrorResponse = {
    [exports.SCRAPI_ERROR_STATUS]: zod_1.z.object({
        code: exports.AuthErrorCode,
        message: zod_1.z.string().optional(),
    }),
};
